"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxeThrowAbilityHandler = exports.AxeThrowActorAbilityFactory = exports.AxeThrowAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
class AxeThrowAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AxeThrow;
        this.__typeName = "AxeThrow";
    }
}
exports.AxeThrowAbilityArgs = AxeThrowAbilityArgs;
let AxeThrowActorAbilityFactory = class AxeThrowActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AxeThrow", "OneEnemies", 1);
    }
};
AxeThrowActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AxeThrow")
], AxeThrowActorAbilityFactory);
exports.AxeThrowActorAbilityFactory = AxeThrowActorAbilityFactory;
let AxeThrowAbilityHandler = class AxeThrowAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        var _a;
        const [selectedEnemy] = ability.args.target.actorIds;
        const invokerClass = (_a = container.getActor(ability.invokerId)) === null || _a === void 0 ? void 0 : _a.classType;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 55)
            ],
            projectileType: invokerClass === ActorType_1.ActorType.WarriorJoe ? "GlowingSpinningHatchet" :
                invokerClass === ActorType_1.ActorType.Warrior ? "SpinningHatchet"
                    : "WhiteVaporBall",
            projectilePath: "line",
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(5),
                    effect: new Vulnerability_1.VulnerabilityEffectArgs(2),
                });
            }
        });
    }
};
AxeThrowAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AxeThrow)
], AxeThrowAbilityHandler);
exports.AxeThrowAbilityHandler = AxeThrowAbilityHandler;
